export const DEV_EXPERIMENT_SUFFIX = '--dev';
